import { api } from "./api"
import URI from "./URI"

export const getUserBankDetails = () => {
    return api(URI.userBankDetails,{
        tokenRequired:true
    })
}

export const parseBankAccounts = (data) => {
    // TODO: Add null check
    // TODO: Add filter for Savings account
    return data?.filter(account => {
        return account.group === "SAV"
    }).map(account => {
        return {
            bankAccountNumber: account.accountId,
            schemeDescription: account.schemeDescription,
            balance: parseFloat(account.balance),
            availableBalance: parseFloat(account.availBalance),
            blockedAmount: parseFloat(account.balance) - parseFloat(account.availBalance)
            // TODO: Assuming its currencyCode = "INR"
        }
    }) || []
}